// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2BIgx","title":"ClientReferral_title__2LTEm","itemText":"ClientReferral_itemText__1eJ4-"};